import type { TFunction } from "i18next";

/**
 * Timeline track keys are raw wire values (`eventLayer` / `state` / `type`,
 * lowercased) that the timeline also matches on, so they are never translated
 * in place — this maps a key to a display label at the render edge. A key with
 * no entry falls back to the previous title-casing, which is what an unknown
 * layer arriving from the API has always rendered as.
 */
export const trackLabel = (key: string, t: TFunction<"machines">): string => {
  const translated = t(`trackLabels.${key}` as "trackLabels.dig", {
    defaultValue: "",
  });

  if (translated) return translated;

  return key
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
